export default {
  startGame: 'startGame',
  finishGame: 'finishGame',
}
